import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddTemporaryConnectionMutationVariables = Types.Exact<{
  data: Types.AddTemporaryConnectionInput;
}>;


export type AddTemporaryConnectionMutation = { __typename?: 'Mutation', addTemporaryConnection: boolean };


export const AddTemporaryConnectionDocument = gql`
    mutation AddTemporaryConnection($data: AddTemporaryConnectionInput!) {
  addTemporaryConnection(data: $data)
}
    `;
export type AddTemporaryConnectionMutationFn = Apollo.MutationFunction<AddTemporaryConnectionMutation, AddTemporaryConnectionMutationVariables>;

/**
 * __useAddTemporaryConnectionMutation__
 *
 * To run a mutation, you first call `useAddTemporaryConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTemporaryConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTemporaryConnectionMutation, { data, loading, error }] = useAddTemporaryConnectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddTemporaryConnectionMutation(baseOptions?: Apollo.MutationHookOptions<AddTemporaryConnectionMutation, AddTemporaryConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTemporaryConnectionMutation, AddTemporaryConnectionMutationVariables>(AddTemporaryConnectionDocument, options);
      }
export type AddTemporaryConnectionMutationHookResult = ReturnType<typeof useAddTemporaryConnectionMutation>;
export type AddTemporaryConnectionMutationResult = Apollo.MutationResult<AddTemporaryConnectionMutation>;
export type AddTemporaryConnectionMutationOptions = Apollo.BaseMutationOptions<AddTemporaryConnectionMutation, AddTemporaryConnectionMutationVariables>;